import React from 'react';
import Button from '@material-ui/core/Button';
import { useButtonStyles } from '../pages/signup/components/styles';

interface MainButtonProps {
    text: string;
    disabled?: boolean;
    style?: React.CSSProperties;
    className?: string;
    onClick?: () => unknown;
}

const MainButton: React.FC<MainButtonProps> = ({
    onClick,
    text,
    style,
    disabled,
    className,
}) => {
    const { mainButton } = useButtonStyles();
    return (
        <Button
            color="primary"
            variant="contained"
            onClick={onClick}
            style={style}
            className={`${mainButton} ${className}`}
            disabled={disabled}
        >
            {text}
        </Button>
    );
};

export default MainButton;
